import { computed, reactive, readonly, toRaw, toRefs } from 'vue'
import { httpInstance } from './http'
import { products, setProducts } from './product'
import { setTransport } from './transport'
import { setBonusCode } from './bonusCode'
import { setClientData } from './clientData'
import { shopAnalyticsBeginCheckout } from '../../../../../Greativ/shop/analytics'
import axios from 'axios'

const state = reactive({
  settings: {},
  globalMessage: '',
  errorMessage: '',
  expiresAt: 0,
  isReady: false,
  extraProducts: [],
})

export async function init() {
  try {
    const [basketData] = await Promise.all([
      httpInstance.get('basket'),
      loadExtraProducts(),
    ])
    const {
      data: { items, transport, clientData, basket, success, message },
    } = basketData
    if (!success && message) {
      state.globalMessage = message
    }

    if (basket) {
      state.settings = basket

      setBonusCode(basket.bonusCode || null)

      if (basket.expiresAt) {
        state.expiresAt = basket.expiresAt * 1000
      }

      shopAnalyticsBeginCheckout({
        items: items || [],
        bonusCode: basket.bonusCode,
      })
    }

    setProducts(items || [])
    setTransport(transport || [])

    if (clientData) {
      setClientData(clientData)
    }
  } catch (error) {
    console.error(error)
  } finally {
    state.isReady = true
  }
}

export const refreshBasketItems = async () => {
  try {
      const {
      data: { basket, items, transport },
    } = await httpInstance.get('basket')
    if (!basket) {
      throw new Error('err')
    }
    setProducts(items || [])
    setTransport(transport || [])
  } catch (e) {
    console.error(e)
  }
}

export const isReady = readonly(toRefs(state).isReady)

export const globalMessage = readonly(toRefs(state).globalMessage)

export function setGlobalMessage(message) {
  state.globalMessage = message
}

export const basketId = computed(() => {
  if (typeof state.settings.id !== 'undefined') {
    return state.settings.id
  }

  return null
})

export const currency = computed(() => {
  if (typeof state.settings.currency !== 'undefined') {
    return state.settings.currency
  }

  return null
})

export const isEmpty = computed(() => {
  return !products.value.length
})

export const termsHeading = computed(() => {
  if (state.settings.termsHeading) {
    return state.settings.termsHeading
  }
  return ''
})

export const termsLink = computed(() => {
  if (state.settings.termsLink) {
    return state.settings.termsLink
  }
  return ''
})

export const allowedInvoicePayment = computed(
  () => !!state.settings.allowInvoicePayment
)

export const expiresAt = readonly(toRefs(state).expiresAt)
export const setExpiresAt = (expiresAt) => {
  state.expiresAt = expiresAt
}

export const settings = computed(() => {
  return toRaw(state.settings)
})

export const setSettings = (settings) => {
  state.settings = settings
}

export const loadExtraProducts = async () => {
  try {
    const {
      data: { success, products },
    } = await axios.get(
      'get/api/shop/products?page=1&page_limit=999&only[]=show_in_basket'
    )
    if (!success) {
      throw new Error('err')
    }
    state.extraProducts = products
  } catch (error) {
    state.extraProducts = []
    console.error(error)
  }
}
export const extraProducts = toRefs(state).extraProducts
